module.exports = __webpack_public_path__ + "media/hawthorn_origin_tvc.cd547c72.mp4";